import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, notification } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { EditFilled, PlusCircleFilled } from "@ant-design/icons";
const { Text } = Typography;

const LogisticsMineList = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [logisticsMineList, setLogisticsMineList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return (
					<Button
						type="primary"
						icon={<EditFilled twoToneColor={"white"} />}
						onClick={(e) =>
							history.push(`/logistics/origin/update/${record.id}`)
						}
					/>
				);
			},
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	useEffect(() => {
		getLogisticsMineList();
	}, []);

	const getLogisticsMineList = async () => {
		setLoading(true);

		const url = api + "/logistics/mine/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						name: item.name,
					});
				});
				setLogisticsMineList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const addNewLogisticsMine = () => {
		history.push("/logistics/origin/new");
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Button
					onClick={addNewLogisticsMine}
					type="primary"
					size="large"
					style={{
						width: 210,
					}}
					icon={<PlusCircleFilled />}
				>
					New Logistics Mine
				</Button>
				<CustomTable
					columns={columns}
					data={logisticsMineList}
					isScroll={false}
				/>
			</Flex>
		);
	};

	return (
		<Layout title="Logistics Mines" description="Mine List">
			<Flex vertical gap={"large"}>
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default LogisticsMineList;
